export default "__VITE_ASSET__D0Ill7LE__"